export const realationsTypes = {
    passways_places_tuple: 'passways_places_tuple',
    passways_pcc_tuple: 'passways_pcc_tuple',
    passways_perimeter_tuple: 'passways_perimeter_tuple',
    passways_zones_tuple: 'passways_zones_tuple',
    places_zones_tuple: 'places_zones_tuple',
};
